import React from 'react';
import Page from './Page';
import PageFooter from './PageFooter';
import PageHeader from './PageHeader';

const CoverPage = ({dashboard, dates, organization}) => (
    <Page className="d-flex flex-column justify-content-between">
        <PageHeader dashboard={dashboard} dates={dates} organization={organization} />
        <h1 className="text-center title">
            Survey Report
        </h1>
        <PageFooter />
    </Page>
);

export default CoverPage;
